module.exports = __webpack_public_path__ + "img/top_bg_1.e6307325.png";